/**
 * Gedeelde typen en labels voor API en frontend.
 * De waarden komen één-op-één overeen met de enums in `apps/api/prisma/schema.prisma`.
 */
export const ROLE_LABELS = {
    ADMIN: 'admin',
    ANALYST: 'prijsanalist',
};
export const PRODUCT_STATUS_LABELS = {
    DRAFT: 'Concept',
    ACTIVE: 'Actief',
    ARCHIVED: 'Gearchiveerd',
};
export const SOURCE_STATUS_LABELS = {
    DRAFT: 'Concept',
    TESTED: 'Getest',
    ACTIVE: 'Actief',
    PAUSED: 'Gepauzeerd',
    ARCHIVED: 'Gearchiveerd',
};
export const MEASUREMENT_STATUS_LABELS = {
    PENDING: 'In wachtrij',
    RUNNING: 'Bezig',
    SUCCESS: 'Succesvol',
    VARIANT_NOT_FOUND: 'Variant niet gevonden',
    VARIANT_MISMATCH: 'Variant komt niet overeen',
    PRICE_NOT_FOUND: 'Prijs niet gevonden',
    PAGE_CHANGED: 'Pagina gewijzigd',
    BLOCKED: 'Geblokkeerd',
    TIMEOUT: 'Time-out',
    VAT_UNCONFIRMED: 'Btw niet bevestigd',
    FEED_NO_MATCH: 'Niet in XML-feed',
    FEED_DUPLICATE: 'Dubbel in XML-feed',
    FEED_UNAVAILABLE: 'XML-feed onbereikbaar',
    ERROR: 'Onbekende fout',
};
/** Een meting telt als geldig zodra de status SUCCESS is; alle andere laten de dagprijs leeg. */
export function isSuccessStatus(status) {
    return status === 'SUCCESS';
}
export const JOB_STATUS_LABELS = {
    SCHEDULED: 'Ingepland',
    RUNNING: 'Bezig',
    COMPLETED: 'Afgerond',
    PARTIAL: 'Deels mislukt',
    FAILED: 'Mislukt',
};
export const IMPORT_ROW_STATUS_LABELS = {
    ADD: 'Toevoegen',
    UPDATE: 'Bijwerken',
    EXISTS: 'Bestaat al',
    DUPLICATE: 'Duplicaat',
    REJECTED: 'Afgewezen',
};
//# sourceMappingURL=types.js.map